import { Moment } from 'moment-timezone';

import { IApiError } from 'routes/waitlist/Summary/types';

export const cleanPhone = (phone: string) => phone.replace(/[^0-9]/g, '');

export type TAvailableCurrencies = 'USD';

type TCurrencyFormats = {
  [key in TAvailableCurrencies]: Intl.NumberFormat;
};

const dollarUS = Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
});

const currencyFormats: TCurrencyFormats = {
  USD: dollarUS,
};

export const formatCurrency = (
  amount: string | number,
  currency: TAvailableCurrencies = 'USD',
) => {
  const numberAmount = Number(amount);

  return currencyFormats[currency].format(numberAmount);
};

export const formatTime = (time: Moment) => {
  const template = time.minutes() > 0 ? 'h:mm A' : 'h A';

  return time.format(template);
};

export const formatError = (errors?: IApiError[] | string | null) => {
  if (!errors || !Array.isArray(errors)) {
    return '';
  }

  const errorString = errors
    .map((error) => error.full_message || error.message)
    .join('\n');

  return errorString === '\n' ? '' : errorString;
};

/**
 * Takes a string in the format of 4.3423 and returns 4.34%
 * @param percentage
 * @returns string
 */
export function formatPercentage(percentage: string): string {
  return `${Number(percentage).toFixed(2).replace('.00', '')}%`;
}
